module.exports = __webpack_public_path__ + "static/ampol-c14c626c0af3515bdea54eb6177aaf0b.svg";